module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3894461559/src/~/babel-runtime/core-js/get-iterator.js
// module id = Whvj
// module chunks = 6